import React, { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/browser';
import { Redirect } from 'react-router-dom';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (process.env.REACT_APP_NODE_ENV === 'production') {
      Sentry.captureException(error, { extra: { ...errorInfo } });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Redirect
          to={{
            pathname: '/errors',
          }}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
